import PropTypes from 'prop-types';
import React from 'react';
import {Box, CircularProgress, Fade, Typography, styled} from '@mui/material';

const Progress = styled(CircularProgress)(props => ({
  marginRight: !props.direction || props.direction === 'row' ? 16 : 0,
  marginBottom: props.direction === 'column' ? 16 : 0,
}));

const Loading = ({
  size = 20,
  timeout = 800,
  direction = 'row',
  message = 'Loading...',
  includeDescription,
  ...props
}) => (
  <Fade in timeout={timeout}>
    <Box
      padding={2}
      display="flex"
      flexDirection={includeDescription ? 'column' : direction}
      justifyContent="center"
      alignItems="center"
      margin="auto"
      data-qe="loading"
      {...props}
    >
      <Progress size={includeDescription ? 50 : size} direction={direction} />

      {!includeDescription && <Typography>{message}</Typography>}

      {includeDescription && (
        <Typography
          variant="h5"
          color="text.secondary"
          fontWeight="bold"
          padding={1}
        >
          {message}
        </Typography>
      )}

      {includeDescription && (
        <Typography color="text.secondary">One moment please</Typography>
      )}
    </Box>
  </Fade>
);

Loading.propTypes = {
  message: PropTypes.string,
  size: PropTypes.number,
  direction: PropTypes.string,
  timeout: PropTypes.number,
  includeDescription: PropTypes.bool,
};

export default Loading;
